module.exports = __webpack_public_path__ + "img/shichang.f7f3b8da.png";